<template lang="pug">
  .base
    .row
    .span
      .row
        h3
          span.blue 有価証券や保険、不動産に関するワンポイントアドバイス
      .row
        h3.subtitle もし以下の資産状況に該当する場合は是非ご相談ください。
      .row
        .message
          table
            tr
              th 非上場株式の財産がある
              td 非上場株式が高額に評価されることもあるため、現在の株価を知っておくことをお勧めします。
            tr
              th オーナー株式の財産がある
              td 創業当時から比較すると株式の評価が上がっている可能性があります。この場合、株式を相続したご家族が相続税の納税資金に困ってしまうおそれがあります。
            tr
              th 保険金の受取人がわからない
              td 受取人が誰に指定されているか確認してください。受取人がすでに亡くなっている場合、受取人の相続人が保険金を受け取ることになり、想定外の人に保険金がわたっていまう可能性があります。
            tr
              th オーナー株式の財産はあるが保険はかけていない場合
              td 事業の後継者でない相続人に対しては、生命保険を活用することによって、相続人間のバランスをとることが可能です。
            tr
              th 遺産全体に占める不動産の割合が7割を超えている
              td 不動産評価が高い場合、相続したご家族が納税資金に窮する可能性があります。現在の不動産価値を評価するとともに、相続税申告時に不動産の評価を下げる対策を講じることをお勧めします。

      .row
        h3
          span.blue {{title}}
      .row
        h3.subtitle {{subTitle}}
      .row
        .message {{message}}
      .row
        h3
          span.blue ZOOMを使い各専門家と相談が可能
      .row
        .message 相続問題が発生した際、ZOOMを使い各専門家（弁護士・税理士・不動産鑑定士）と同時にワンストップ相談することも可能です。
      .row
        .button_area
          button.blue_button(@click="go_mail")
            | 当サイトの専門家に
            br
            | 無料メール相談をする

      //.row
      //  .button_area
      //    button.blue_button(@click="go_zoom")
      //      | ZOOM相談予約フォームはこちら
</template>

<script lang="js">
import AreaTemplate from '@/components/step03/AreaTemplate.vue';

export default {
  components: {
    AreaTemplate,
  },
  props: {
    priceData: {
      type: Object,
      default: {},
    },
  },
  computed: {
    title() {
      if (this.priceData.style === 1) {
        return '財産の相続について迷ったらいますぐご相談ください';
      }
      return '財産の相続について迷ったらいますぐにご相談ください';
    },
    subTitle() {
      // if (this.priceData.style === 1) {
      //   return '当サイトの遺産相続専門家が親身になって回答いたします。';
      // }
      // return '財産の相続について迷ったらいますぐにご相談ください';
      return '';
    },
    message() {
      if (this.priceData.style === 1) {
        return '何も対策をしないと税負担が多くなる可能性があります。対策をすると税負担が下がる可能性もあるので迷わずご相談ください。ご自身の財産について、何から手をつけたらいいか分からない等のお悩みがございましたら、お気軽に下記のフォームリンクよりご相談ください。遺産相続の専門家が回答いたします。';
      }
      return '死後10カ月以内で相続手続きが必要ですので、早急にご相談ください。期限後申告では余計な税金が発生しますのでお早めに。本人が急死して、何から手をつけたらいいのか分からない等のお悩みがございましたら、お気軽に下記のフォームリンクよりご相談ください。遺産相続の専門家が回答いたします。';
    },
  },
  mounted() {
    this.$emit('area_data', {
      title: this.title,
      subTitle: this.subTitle,
      message: this.message,
    });
  },
  methods: {
    go_mail(e) {
      this.$emit('go_mail');
    },
    go_zoom(e) {
      window.open('https://imasugu-souzoku.com/form.html');
    },
  },
};
</script>

<style lang="sass" scoped>
.base
  width: 100%
  margin-top: 40px
  margin-bottom: 80px
  .row
    h2
      display: flex
      align-items: center
      img
        width: 30px
        margin-right: 10px
    h3
      margin-top: 10px
      font-size: 1.5em
    h3.subtitle
      font-size: 1.17em
    .message
      margin-top: 10px
      table
        width: 100%
        border-collapse: collapse
        th, td
          border: solid 1px $color-black
          padding: 5px
          font-size: 90%
        th
          font-weight: normal
          text-align: left
    .button_area
      margin-top: 40px
      button
        width: 100%
        max-width: 360px
.blue
  color: $color-orange
</style>